import UnitsApi from '../../apis/Units';

export default {
    namespaced: true,
    state: {
        units: []
    },
    mutations: {
        set_units (state, data) {
            state.units = data;
        }
    },
    actions: {
        async getUnits({commit, dispatch}, filters) {
            return await UnitsApi.get_all(filters)
                .then( response => {
                    commit('set_units', response.data)
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al listar unidades de medida, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async store({dispatch}, unit) {
            return await UnitsApi.store(unit)
                .then( response => {
                    dispatch('notifications/store_notification', {
                        type: 'success',
                        message: 'La unidad se registró de forma correcta.'
                    }, {root: true});
                    dispatch('getUnits')
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al registrar, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async update({dispatch}, unit) {
            return await UnitsApi.update(unit)
                .then( response => {
                    dispatch('notifications/store_notification', {
                        type: 'success',
                        message: 'La actualización se realizó de forma correcta'
                    }, {root: true});
                    dispatch('getUnits')
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al actualizar, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async change_status({dispatch}, unit) {
            let action = (unit.active) ? 'inactivación' : 'activación';
            return await UnitsApi.change_status(unit)
                .then( response => {
                    dispatch('notifications/store_notification', {
                        type: 'success',
                        message: 'La ' + action + ' se relizó de forma correcta.'
                    }, {root: true});
                    dispatch('getUnits')
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al realizar la ' + action + ', vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async delete({dispatch}, unit) {
            return await UnitsApi.delete(unit)
                .then( response => {
                    dispatch('notifications/store_notification', {
                        type: 'success',
                        message: 'La eliminación se realizó de forma correcta.'
                    }, {root: true});
                    dispatch('getUnits')
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al eliminar, vuelva a intentarlo.'
                    }, {root: true});
                })
        }
    }
}